<template>
  <table-controls-vue
    :has-sticky="true"
    v-if="!loading && programs.length"
    class="is-border">
    <table class="table is-narrow is-fullwidth is-striped-v is-first-fixed-medium is-last-fixed-medium has-actionsontd">
      <thead

        class="has-cells-vcentered">
        <tr class="is-size-6">
          <th
            class="is-paddingless has-text-centered"
            style="z-index:2;">
            <columns-toggles
              :entries="columnsList"
              :source="columns"
              @update="updateColumns"></columns-toggles>
          </th>
          <th class="is-groupcols-1a">
            <sortable
              @sort="sort('name', $event)"
              sort-id="name"
              :sort="sortBy.name"
              label="Nom"></sortable>
            <div class="deco"></div>
          </th>
          <th
            v-if="isDistributeur && showColumn('account__name')"
            class="is-groupcols-1a">
            <sortable
              @sort="sort('account__name', $event)"
              sort-id="account__name"
              :sort="sortBy.account__name"
              label="Promoteur"></sortable>
            <div class="deco"></div>
          </th>
          <th
            v-if="isAdmin && showColumn('status')"
            class="is-groupcols-1a">
            Statut<div class="deco"></div>
          </th>
          <th
            v-if="showColumn('tax_dispositifs')"
            class="is-groupcols-1b">
            Dispositifs<div class="deco"></div>
          </th>
          <th
            v-if="showColumn('operation_type')"
            class="is-nowrap is-groupcols-1b">
            Type d'op<div class="deco"></div>
          </th>
          <th
            v-if="showColumn('zip_code')"
            class="is-nowrap is-groupcols-1b">
            Code Postal<div class="deco"></div>
          </th>
          <th
            v-if="showColumn('city')"
            class="is-groupcols-1b">
            Ville<div class="deco"></div>
          </th>
          <th
            v-if="showColumn('date_livraison')"
            class="is-nowrap is-groupcols-2b">
            <sortable
              @sort="sort('date_livraison', $event)"
              sort-id="date_livraison"
              :sort="sortBy.date_livraison"
              label="Date de livraison"></sortable>
            <div class="deco"></div>
          </th>
          <th
            v-if="showColumn('date_actabilite')"
            class="is-groupcols-2b">
            <sortable
              @sort="sort('date_actabilite', $event)"
              sort-id="date_actabilite"
              :sort="sortBy.date_actabilite"
              label="Actable"></sortable>
            <div class="deco"></div>
          </th>
          <th
            v-if="isAdmin && isPromoteur && showColumn('available_lots')"
            class="is-nowrap is-groupcols-2b">
            Lots dispo.<div class="deco"></div>
          </th>
          <th
            v-if="isAdmin && isPromoteur && showColumn('lot_total')"
            class="is-nowrap is-groupcols-2b">
            Lots total<div class="deco"></div>
          </th>
          <th
            v-if="isAdmin && isPromoteur && showColumn('remuneration')"
            class="is-groupcols-2b">
            <sortable
              @sort="sort('remuneration', $event)"
              sort-id="remuneration"
              :sort="sortBy.remuneration"
              label="Rémuneration"></sortable>
            <div class="deco"></div>
          </th>
          <th
            v-if="showColumn('construction_steps')"
            class="is-nowrap is-groupcols-2c">
            État d'avancement<div class="deco"></div>
          </th>
          <th
            v-if="isAdmin && isPromoteur && showColumn('diffusion_enabled') && mgcEnabled"
            class="is-nowrap is-groupcols-1c">
            <sortable
              @sort="sort('diffusion_enabled', $event)"
              sort-id="diffusion_enabled"
              :sort="sortBy.diffusion_enabled"
              label="Multi-diff."></sortable>
            <div class="deco"></div>
          </th>
          <th
            v-if="isAdmin && showColumn('created_on')"
            class="is-nowrap is-groupcols-1c">
            <sortable
              @sort="sort('created_on', $event)"
              sort-id="created_on"
              :sort="sortBy.created_on"
              label="Création"></sortable>
            <div class="deco"></div>
          </th>
          <th class="has-text-centered"></th>
        </tr>
      </thead>
      <tbody
        class="has-cells-vcentered">
        <tr>
          <td
            v-if="multiselection && ['ProgramList'].includes($route.name)"
            colspan="15"
            style="padding: 0">
            <div
              class="is-flex is-nowrap is-align-items-center container_select_multiple_programlist">
              <a
                :style="!selectedItems.length > 0? 'background-color: #219CED' : 'background-color: #8CBB7D'"
                class="select_multiple_programlist"
                @click="$store.commit('selectAllMultiselectionItems')">
                <i
                  style="font-size: 17px; padding: 0px 22px 0px 16px"
                  class="far fa-check-double"></i>
                <span class="is-padding-left-xxsmall">{{ !selectedItems.length > 0 ? 'Cliquez ici pour sélectionner toutes les lignes de la page' : 'Déselectionnez toutes les lignes de la page' }}</span>
              </a>
            </div>
          </td>
        </tr>
        <tr
          v-for="(p, i) in programs"
          :key="p.pk"
          class="is-size-6"
          :id="'e' + p.pk"
          :class="{'has-status-bar--left has-status-bar--draft': lastOpenedItemPk === p.pk}">
          <td class="is-cell-hoverable has-text-centered">
            <router-link
              v-if="!multiselection"
              :to="{name: 'ProgramVue', params: {id: p.pk}}"
              class="is-inline-flex">
              <avatar
                :item="p"
                :i="i"></avatar>
            </router-link>
            <multiselect-button
              v-else
              :data="p">
            </multiselect-button>
          </td>
          <td class="is-cell-hoverable">
            <router-link
              :to="{name: 'ProgramVue', params: {id: p.pk}}"
              :class="[p.is_optionable? 'fullLink' : '']"
              :title="p.name">
              {{ p.name | truncate }}
            </router-link>
            <p
              class="has-text-annonce is-small is-italic"
              v-if="!p.is_optionable">
              Non optionnable
            </p>
          </td>
          <td
            v-if="showColumn('account__name')"
            class="is-cell-hoverable">
            <router-link
              v-if="isPromoteurDetailsActivated(p.promoteur)"
              :to="{name: 'PromoteurPresentation', params: {id: p.promoteur.pk}}"
              :class="[p.is_optionable? 'fullLink' : '']"
              :title="p.promoteur.name">
              <span
                class="fullLink"
                v-if="isAdmin">
                {{ p.promoteur.name }}
              </span>
              <span v-else>{{ p.promoteur.name }}</span>
            </router-link>
            <span v-else>
              <span
                class="fullLink"
                v-if="isAdmin">
                {{ p.promoteur.name }}
              </span>
              <span v-else>{{ p.promoteur.name }}</span>
            </span>
          </td>
          <td v-if="isAdmin && showColumn('status')">
            <span
              class="tag"
              :class="p.status | tagColor">{{ p.status | workflowLabel }}</span>
          </td>
          <td
            v-if="showColumn('tax_dispositifs')"
            class="is-nowrap">
            <span
              v-if="p.tax_dispositifs && p.tax_dispositifs.length"
              :title="p.tax_dispositifs | prettyTaxDispositifs(taxDispositifsData)">
              {{ p.tax_dispositifs | prettyTaxDispositifs(taxDispositifsData) | truncate }}
            </span>
            <span v-else>--</span>
          </td>
          <td v-if="showColumn('operation_type')">
            <span v-if="p.operation_type">{{ p.operation_type | operationTypeLabel }}</span>
            <span v-else>--</span>
          </td>
          <td v-if="showColumn('zip_code')">
            <span v-if="p.address && p.address.zip_code">{{ p.address.zip_code }}</span>
            <span v-else>--</span>
          </td>
          <td v-if="showColumn('city')">
            <span v-if="p.address && p.address.city">{{ p.address.city }}</span>
            <span v-else>--</span>
          </td>
          <td v-if="showColumn('date_livraison')">
            <span v-if="p.date_livraison">{{ p.date_livraison | trimestre }}</span>
            <span v-else>-</span>
          </td>
          <td v-if="showColumn('date_actabilite')">
            <span v-if="p.date_actabilite">{{ p.date_actabilite | actableStatus }}</span>
            <span v-else></span>
          </td>
          <!-- <td v-if="isPromoteur && showColumn('lot_dispo')">
            <span v-if="allotment">{{allotment}}</span>
            <span v-else>-</span>
          </td>
          <td v-else-if="!(isDistributeur) && showColumn('lot_dispo')">
            <span v-if="p.lot_counts.available || p.lot_counts.optioned">{{(p.lot_counts.available || 0) + (p.lot_counts.optioned || 0)}}</span>
            <span v-else>-</span>
          </td> -->
          <td v-if="isAdmin && isPromoteur && showColumn('available_lots')">
            <span v-if="p.available_lots || p.optioned_lots">{{ (p.available_lots || 0) + (p.optioned_lots || 0) }}</span>
            <span v-else>-</span>
          </td>
          <td v-if="isAdmin && isPromoteur && showColumn('lot_total')">
            <span v-if="p.available_lots || p.optioned_lots || p.reserved_lots || p.sold_lots || p.other_lots">
              {{ (p.available_lots || 0) + (p.optioned_lots || 0 ) + (p.reserved_lots || 0) + (p.sold_lots || 0) + (p.other_lots || 0) }}
            </span>
            <span v-else>-</span>
          </td>
          <td v-if="isAdmin && isPromoteur && showColumn('remuneration') && displayRemuneration">
            <span v-if="p.remuneration">{{ p.remuneration|prettyPrice }}%</span>
            <span v-else>--</span>
          </td>
          <td v-if="showColumn('construction_steps')">
            <span
              v-if="p.construction_steps"
              class="tag is-info">{{ p.construction_steps | programStepProgressLabel }}</span>
            <span v-else>-</span>
          </td>
          <td v-if="isAdmin && isPromoteur && showColumn('diffusion_enabled') && mgcEnabled">
            <span v-if="p.diffusion_enabled">Oui</span><span v-else>Non</span>
          </td>
          <td v-if="isAdmin && isPromoteur && showColumn('created_on')">
            {{ p.created_on | prettyDate }}
          </td>
          <td class="has-text-centered">
            <display-button-list
              :buttons="buttonList"
              :data="p"
              :hide-text-when-solo="true">
            </display-button-list>
          </td>
        </tr>
      </tbody>
    </table>
  </table-controls-vue>
</template>

<script>
import StockMixin from './StockMixin'
import ProgramListMixin from './ProgramListMixin'
import ProgramCrudMixin from '@/components/programs/ProgramCrudMixin'
import { Multiselection } from '@/mixins'
import { mapGetters } from 'vuex'

export default {
  name: 'ProgramList',
  mixins: [
    StockMixin,
    ProgramListMixin,
    ProgramCrudMixin,
    Multiselection
  ],
  data () {
    return {
      columnsConfResource: 'programs'
    }
  },
  computed: {
    ...mapGetters(['accounts']),
    columnsShow () {
      const columns = {}
      if (this.isDistributeur) {
        columns.account__name = { label: 'Promoteur' }
      }
      if (this.isAdmin && this.isPromoteur) {
        columns.status = { label: 'Statut' }
      }
      columns.tax_dispositifs = { label: 'Dispositifs' }
      columns.operation_type = { label: 'Type d\'opération' }
      columns.zip_code = { label: 'Code Postal' }
      columns.city = { label: 'Ville' }
      columns.date_livraison = { label: 'Date de livraison' }
      columns.date_actabilite = { label: 'Actable' }
      if (this.isAdmin && this.isPromoteur) {
        columns.available_lots = { label: 'Lots dispo.' }
        columns.lot_total = { label: 'Lots total' }
        columns.remuneration = { label: 'Rémunération' }
      }
      columns.construction_steps = { label: 'État d\'avancement' }
      if (this.isAdmin && this.isPromoteur && this.mgcEnabled) {
        columns.diffusion_enabled = { label: 'Multi-diff.' }
      }
      if (this.isAdmin && this.isPromoteur) {
        columns.created_on = { label: 'Création' }
      }
      return columns
    },
    arrayKey () {
      if (this.$route.name === 'LotList') return 'lots'
      else return 'programs'
    }
  },
  methods: {
    isPromoteurDetailsActivated (promoteur) {
      const account = this.accounts.find(a => a.name === promoteur.name).promoteur_details_activated
      if (account) {
        return account
      }
    },
    sort (name, v) {
      this.$emit('sort', name, v)
    }
  }
}
</script>

<style lang="sass">
.container_select_multiple_programlist
  width: 100%

.select_multiple_programlist
  text-decoration: none !important
  padding: 13px
  width: 100%
  color: white

.select_multiple_programlist:hover
  color: white
  text-decoration: none
</style>
